import { render, staticRenderFns } from "./reporta9.vue?vue&type=template&id=1e6773ae&"
import script from "./reporta9.vue?vue&type=script&lang=js&"
export * from "./reporta9.vue?vue&type=script&lang=js&"
import style0 from "./reporta9.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports